export default {
      id: "subscribe-usage",
      viewBox: "0 0 36 24",
      url: __webpack_public_path__ + "sprite.1793797381340.svg#subscribe-usage",
      toString: function () {
        return this.url;
      }
    }